import styled from 'react-emotion'
import { emptyArr } from 'util/arrays'
import themeVars from 'ui_theme/site/globals/site.variables'

import { Flex, Box, Icon } from 'shared/ui'

import Recipient from './Recipient'

const Header = ({ className, label, recipients = emptyArr, ticketId }) => {
  return (
    <Flex className={className}>
      <Flex flex="1 0 90%" noOverflow>
        <Icon name="twitter" size="small" color="#31aef4" />
        <Box ml={2}>
          <Recipient label={label} recipients={recipients} />
        </Box>
      </Flex>
    </Flex>
  )
}

export default styled(Header)`
  flex-shrink: 0;
  margin: 0 -${themeVars.large} ${themeVars.mini};
  padding: ${themeVars.nano} ${themeVars.large};
  border-bottom: 1px solid ${themeVars.ultraDust};
  border-top: 1px solid ${themeVars.ultraDust};
  background-color: ${themeVars.brightSuperDark};
  white-space: nowrap;
`
